<!--<img #staticMapImage src="" alt="{{escola.nome}}" border="0" class="map-image">-->
<div>
  <img #staticMapImage class="static-map" alt="{{escola.nome}}" border="0" width="100%"
       src="https://maps.googleapis.com/maps/api/staticmap?size={{mapSizeWidth}}x{{mapSizeHeight}}&scale=2&format=jpg&sensor=false&markers=size:tiny%7C{{this.escola.latitude}},{{this.escola.longitude}}&center={{this.escola.latitude}},{{this.escola.longitude}}&zoom=13&maptype=roadmap&key={{this.GOOGLE_MAPS_API_KEY}}">
</div>
